import { render, staticRenderFns } from "./flowXStockPrice.vue?vue&type=template&id=2a6f7ea2&scoped=true"
import script from "./flowXStockPrice.vue?vue&type=script&setup=true&lang=js"
export * from "./flowXStockPrice.vue?vue&type=script&setup=true&lang=js"
import style0 from "./flowXStockPrice.vue?vue&type=style&index=0&id=2a6f7ea2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6f7ea2",
  null
  
)

export default component.exports